<!-- Cabecera del modal -->
<div class="container">
  <div #headerDialog class="header-dialog">
    <div>
      <img [src]="adp_logo" alt="Agente de Prensa" style="width: 8rem;">
    </div>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <!-- <div style="height: 100%;">
    <mat-tab-group style="height: 100%;">
      <mat-tab label="First">
        <section style="border: 1px solid red;">
          <ng-container *ngFor="let item of filteredDataSliceTwo, let last = last">
            <div *ngIf="item.showFirst">
              {{item[name]}}
            </div>
            <app-impact-row [item]="item" [xlabel]="data.type === 1 ? data.xlabel : 0" [ylabel]="data.ylabel"
              [val]="data.params.isVal" [det]="data.params.isDet" [currency]="data.params.currency"
              [typeNotesService]="typeNotesService" [tiersService]="tiersService" [platformService]="platformService">
            </app-impact-row>
            <mat-divider *ngIf="!last"></mat-divider>
          </ng-container>
        </section>
      </mat-tab>
      <mat-tab label="Second"> 
        <pre>
          <code>
            {{filteredDataSliceTwo | json }}
          </code>
        </pre>
      </mat-tab>
      <mat-tab label="Third">
        <p>Name: {{ name }}</p>
      </mat-tab>
    </mat-tab-group>
  </div> -->
  
  
  <!-- Estructura reorganizada -->
  <div class="body-dialog">
    <section class="reporte-detallado">
      <h1 class="main-title"><strong> REPORTE DETALLADO POR {{title}} </strong></h1>
      <div class="reporte-detallado content">
        <div class="duration">
          <img [src]="data?.customer?.logoPath ? data?.customer?.logoPath : 'assets/img/noimage.png'" alt="" width="100%"
          class="img-fluid img-thumbnail" style="max-width: 350px;">
          <div class="data">
            <span>
              Duración: <br>
              <strong>{{data.params.fechaInicio | date:'dd/MM/yyy'}}</strong> - <strong>{{data.params.fechaFin |
                date:'dd/MM/yyy'}}</strong>
            </span>
          </div>
        </div>
        <div class="download-buttons">
          <button type="button" mat-stroked-button (click)="pdf(true)">
            <mat-icon class="pdf">picture_as_pdf</mat-icon>
            <span class="btn-text">Descargar en&nbsp;</span><span>PDF</span>
          </button>
          <button type="button" mat-stroked-button (click)="excel()">
            <mat-icon class="excel">table_chart</mat-icon>
            <span class="btn-text">Descargar en&nbsp;</span><span>Excel</span>
          </button>
          <!-- <button type="button" mat-stroked-button (click)="pdf(false)">
            <mat-icon class="email">email</mat-icon>
            <span class="btn-text">Enviar por&nbsp;</span><span>Email</span>
          </button> -->
        </div>
      </div>
      <!-- <hr> -->
    </section>
  
    <section #infoResultados class="info-resultados">
      <mat-tab-group mat-stretch-tabs>
        <mat-tab label="Resumen">
          <div>
            <adp-details-table [data]="data"></adp-details-table>
            <adp-result-report-table [data]="dataTableOne" [title]="dataTitleOne"
            [totals]="dataTableOneTotals"></adp-result-report-table>
          </div>
        </mat-tab>
        <mat-tab label="Resultados">
          <div class="info-resultados content" (scrolled)="onModalScrollDownTwo()">
            <ng-container *ngFor="let item of filteredDataSliceTwo, let last = last, let i = index">
              <p *ngIf="item.showFirst" class="first-result-title">
                {{item[name]}}
              </p>
              <app-impact-row [item]="item" [xlabel]="data.type === 1 ? data.xlabel : 0" [ylabel]="data.ylabel"
                [val]="data.params.isVal" [det]="data.params.isDet" [currency]="data.params.currency"
                [typeNotesService]="typeNotesService"
                [tiersService]="tiersService"
                [platformService]="platformService">
              </app-impact-row>
              <mat-divider *ngIf="!last"></mat-divider>
            </ng-container>
          </div>
        </mat-tab>
      </mat-tab-group>
    </section>
  </div>
</div>